import React from "react";
import { BatteryLow, CalendarSync, CloudSun, EyeOff, Globe2, MonitorSmartphone } from "lucide-react";
import { useLanguage } from "../../contexts/LanguageContext";

const benefitIcons = [EyeOff, MonitorSmartphone, CalendarSync, CloudSun, Globe2, BatteryLow];

export default function BenefitsSection() {
  const { t } = useLanguage();
  const copy = t("kylendar.benefits");

  return (
    <section id="benefits" className="home-wash relative border-y border-brand-100 bg-[#f0fbf6] py-20 sm:py-24">
      <span className="home-orb -left-10 top-10 h-56 w-56 bg-brand-300/35" aria-hidden="true" />
      <span className="home-orb bottom-0 right-0 h-64 w-64 bg-emerald-200/40" aria-hidden="true" />
      <div className="relative mx-auto max-w-7xl px-5 sm:px-8 lg:px-10">
        <div className="home-section-mark mx-auto max-w-2xl text-center">
          <p className="home-eyebrow">{copy.eyebrow}</p>
          <h2 className="home-title mt-3">{copy.title}</h2>
        </div>

        <div className="mx-auto mt-12 grid max-w-5xl gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {benefitIcons.map((Icon, index) => {
            const [title, body] = copy.items[index];
            return (
            <article
              key={title}
              className="group rounded-xl border border-brand-100/80 bg-white/80 p-5 shadow-[0_14px_28px_-26px_rgba(15,23,42,.42)] transition duration-300 hover:-translate-y-1 hover:border-brand-200 hover:bg-white hover:shadow-[0_24px_44px_-28px_rgba(14,181,126,.32)]"
            >
              <span className="home-icon-well mx-0 rounded-2xl">
                <Icon className="h-5 w-5" aria-hidden="true" />
              </span>
              <h3 className="mt-4 font-display text-sm font-bold text-slate-950">{title}</h3>
              <p className="mt-2 text-sm leading-6 text-slate-500">{body}</p>
            </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
